module.exports = __webpack_public_path__ + "media/images/work_vml-161ee0e652cd017e96edf3a75096533d.jpg";